namespace e5 {
    export interface UrlParamEntries {
        [key: string]: any;
    }

    class UrlGetParams {
        private getQueryPart(url: string): string {
            var partA = url.split("?");
            if (partA.length === 1)
                return "";

            var partB = partA[1].split("#");
            return partB[0];
        }

        /**
         * Returns all the values associated with a given search parameter.
         * 
         * @param url The related URL.
         */
        public entries(url: string = window.location.href): UrlParamEntries {
            var query = this.getQueryPart(url);

            if (!query)
                return {};

            var vars = query.split("&");
            var result: UrlParamEntries = {};
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                var key = decodeURIComponent(pair[0]);
                var value = decodeURIComponent(pair[1] || "");

                var isArray = key.indexOf("[]") !== -1;
                if (isArray) {
                    key = key.split("[]")[0];
                }

                if (isArray) {
                    var lastValue = result[key];
                    if (Array.isArray(lastValue)) {
                        lastValue.push(value);
                    } else {
                        result[key] = [value];
                    }
                } else {
                    result[key] = value;
                }
            }

            return result;
        }

        /**
         * 
         * @param entries A key-value pair object.
         * @param url The related URL.
         */
        public setEntries(entries: UrlParamEntries, url: string = window.location.href): string {
            var result = this.entries(url);

            for (var key in entries) {
                result[key] = entries[key];
            }

            var paramStrings: string[] = [];
            for (var key in result) {
                var value = result[key];
                key = encodeURIComponent(key);
                if (Array.isArray(value)) {
                    for (var i = 0; i < value.length; ++i) {
                        paramStrings.push(key + "[]=" + encodeURIComponent(value[i]))
                    }
                } else {
                    paramStrings.push(key + "=" + encodeURIComponent(value));
                }
            }

            var query = "?" + paramStrings.join("&");

            var partA = url.split("?")[0];
            var partB = partA.split("#");

            if (partB.length > 1) {
                return partA + query + "#" + partB[1];
            }

            return partA + query;
        }

        /**
         * Returns the first value associated with the given search parameter.
         * 
         * @name name The name of the parameter to return.
         * @param fallback The fallback value.
         * @param url The related URL.
         */
        public get(name: string, fallback: string = "", url: string = window.location.href): string {
            var query = this.getQueryPart(url);

            if (!query)
                return fallback;

            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == name) {
                    return decodeURIComponent(pair[1]);
                }
            }
            return fallback;
        }

        /**
         * Returns all the values associated with a given search parameter.
         * 
         * @name name The name of the parameter to return.
         * @param url The related URL.
         */
        public getAll(name: string, url: string = window.location.href): string | string[] {
            var entries = this.entries(url);
            return entries[name] || "";
        }

        /**
         * Returns a Boolean indicating if such a given parameter exists.
         * 
         * @param name The name of the parameter to find.
         * @param url The related URL.
         */
        public has(name: string, url: string = window.location.href): boolean {
            name = encodeURIComponent(name);
            var query = this.getQueryPart(url);
            if (!query)
                return false;

            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == name) {
                    return true;
                }
            }
            return false;
        }

        /**
         * Sets the value associated with a given search parameter to the given value. If there are several values, the others are deleted.
         * 
         * @param name The name of the parameter to set.
         * @param value The value of the parameter to set.
         * @param url The related URL.
         */
        public set(name: string, value: string = "", url: string = window.location.href): string {
            var params: UrlParamEntries = {};
            params[name] = value;
            return this.setEntries(params, url);
        }
    }

    export class Url {

        public static readonly params = new UrlGetParams();

        public static getParams(url: string = window.location.href): UrlParamEntries {
            console.warn("Url.getParams() is deprecated. Use Url.params.entries() instead.");
            return this.params.entries(url);
        }

        public static setParams(url: string, name: UrlParamEntries): string {
            console.warn("Url.setParams() is deprecated. Use Url.params.setEntries() instead.  Hint: the param order is different.");
            return this.params.setEntries(name, url);
        }

        public static getParam(name: string, fallback: string = "", url: string = window.location.href): string {
            console.warn("Url.getParam() is deprecated. Use Url.params.get() instead.");
            return this.params.get(name, fallback, url);
        }

        public static hasParam(name: string, url: string = window.location.href): boolean {
            console.warn("Url.hasParam() is deprecated. Use Url.params.has() instead.");
            return this.params.has(name, url);
        }

        public static setParam(url: string, name: string, value: string = ""): string {
            console.warn("Url.setParam() is deprecated. Use Url.params.set() instead. Hint: the param order is different.");
            return this.params.set(name, value, url);
        }
    }
}